import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';

export const FETCH_APPLIANCE_LIST_ACTIONS = {
    FETCH_APPLIANCES_SUCCESS: 'FETCH_APPLIANCES_SUCCESS',
    FETCH_APPLIANCES_FAILED: 'FETCH_APPLIANCES_FAILED'
};

export function fetchApplianceMapping(options) {
  return dispatch => {
    let url = API_PROTOCOL + BE_SERVER_ENDPOINT;
    if (options.isPublic) {
      url += `/v2.0/public/appliance-name-mapping/pilot/${options.pilotId}`;
    } else {
      url += `/v2.0/dashboard/users/${options.userId}/appliance-name-mapping`;
    }
    axios.get(url, {
        params: {
            locale: options.locale,
            appliances: options.applianceIds
        }
    }).then(
      (response) => {
        dispatch({
          type: FETCH_APPLIANCE_LIST_ACTIONS.FETCH_APPLIANCES_SUCCESS,
          payload: response.data.payload
        })
      },
      (error) =>{
        dispatch({
            type: FETCH_APPLIANCE_LIST_ACTIONS.FETCH_APPLIANCES_FAILED,
            payload: error
        })
      }
    )
  }
}
